<template>
  <div
    v-loading="loading"
    class="order_card_list_wrap"
    element-loading-text="加载中"
  >
    <div class="order_card_list">
      <div
        v-if="!loading && (!data || !data.length)"
        class="order_card_list_empty"
      >
        暂无数据
      </div>
      <order-card-item
        v-for="row in data"
        :key="row.code || row.id"
        :row="row"
        :branch-list="branchList"
        :car-length-options="carLengthOptions"
        :car-model-options="carModelOptions"
        :selected="selectedCodes.includes(row.code)"
        :permissions="permissions"
        @select-change="val => handleSelect(row, val)"
        @detail="row => $emit('detail', row)"
        @copy="row => $emit('copy', row)"
        @dispatch="row => $emit('dispatch', row)"
        @edit="row => $emit('edit', row)"
        @qrcode="row => $emit('qrcode', row)"
        @log="row => $emit('log', row)"
        @more="payload => $emit('more', payload)"
        @refresh="$emit('refresh')"
      />
    </div>
  </div>
</template>

<script>
import OrderCardItem from "./OrderCardItem.vue";
import { VehicleType } from "@/api/orderform";

export default {
  name: "OrderCardList",
  components: { OrderCardItem },
  props: {
    data: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    branchList: { type: Array, default: () => [] },
    permissions: { type: Object, default: () => ({}) },
    selectedCodes: { type: Array, default: () => [] }
  },
  data() {
    return {
      carLengthOptions: [],
      carModelOptions: []
    };
  },
  created() {
    this.loadCarOptions();
  },
  methods: {
    handleSelect(row, selected) {
      this.$emit("select-change", { row, selected });
    },
    loadCarOptions() {
      const baseQuery = {
        name: "",
        pageNum: 1,
        pageSize: 100,
        sortField: "",
        sortType: "",
        status: "0",
        branchCode: ""
      };
      VehicleType({
        ...baseQuery,
        type: "app_vehicleLength"
      }).then(response => {
        this.carLengthOptions = (response.data && response.data.records) || [];
      });
      VehicleType({
        ...baseQuery,
        type: "app_vehicleClassification"
      }).then(response => {
        this.carModelOptions = (response.data && response.data.records) || [];
      });
    }
  }
};
</script>

<style scoped>
.order_card_list_wrap {
  position: relative;
  min-height: 200px;
  margin-bottom: 12px;
}
.order_card_list_wrap ::v-deep .el-loading-spinner {
  top: 72px;
  margin-top: 0;
}
.order_card_list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.order_card_list_empty {
  padding: 40px;
  text-align: center;
  color: #909399;
  font-size: 14px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}
</style>
